import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Breadcrumbs.css';

const Breadcrumbs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't render breadcrumbs on administration routes, actual meeting routes, or the root page
  // Note: completed-meetings page will show breadcrumbs
  if (location.pathname.startsWith('/administration') || 
      location.pathname === '/meeting' ||
      location.pathname.match(/^\/meeting\/[^/]+$/) ||
      location.pathname === '/') {
    return null;
  }

  const breadcrumbItems = [
    {
      label: 'Liminal AI Coach Agent',
      path: '/',
      isActive: location.pathname === '/'
    },
    ...(location.pathname === '/completed-meetings' ? [{
      label: 'Completed Meetings',
      path: '/completed-meetings',
      isActive: true
    }] : [])
  ];

  const handleBreadcrumbClick = (path) => {
    // Don't navigate if clicking on the home breadcrumb when already on home
    if (path === '/' && location.pathname === '/') {
      return;
    }
    navigate(path);
  };

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {breadcrumbItems.map((item, index) => (
          <li key={index} className="breadcrumb-item">
            {index > 0 && <span className="breadcrumb-separator">/</span>}
            <button
              className={`breadcrumb-link ${item.isActive ? 'active' : ''}`}
              onClick={() => handleBreadcrumbClick(item.path)}
              disabled={item.isActive}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs; 